import AppContainer from "../basicLayout/AppContainer";
import system from "./system";
import logistics from "./logistics";
import platform from "./platform";
import supervise from "./supervise";
import mobile from "./mobile";

import Home from "@/views/main/index.vue";
import error404 from "@/views/public/404.vue";
import error403 from "@/views/public/403.vue";
export default [
	//渲染主容器，不用修改
	{
		path: "/",
		name: "appContainer",
		component: AppContainer,
		redirect: "home",
		hideMenu: true,
		children: [
			//首页
			{
				path: "home",
				name: "home",
				component:Home,
			},
		],
	},
	...system,
	...logistics,
	...platform,
	...supervise,
	...mobile,
	//登录
	{
		path: "/login",
		name: "login",
		hideMenu: true,
		meta:{
			appCode:"auth"
		},
		component: (resolve) => require(["@/views/login/login.vue"], resolve),
	},
	{
		path: "/404",
		name: "404",
		hideMenu: true,
		component: error404,
	},
	{
		path: "/403",
		name: "403",
		hideMenu: true,
		component: error403,
	},
];
